<template>
  <div class="watch-content">
    <div class="headerNav">
      <van-nav-bar
        title="我的课程详情"
        left-arrow
        :fixed="true"
        style="background: var(--depYelColor)"
        @click-left="onClickLeft"
      >
        <template #left>
          <i class="iconfont iconjiantou1" style="font-size: 26px"> </i>
        </template>
      </van-nav-bar>
    </div>
    <div class="detail" :style="{ height: height + 'px' || '100%' }">
      <div class="detail-video">
        <!-- 视频播放器主体 -->
        <video
          ref="video"
          class="detail-video-content"
          disablePictureInPicture
          webkit-playsinline="true"
          x5-playsinline=""
          x5-video-player-type="h5"
          x5-video-player-fullscreen=""
          playsinline
          preload="auto"
          :src="videoUrl"
          @timeupdate="updateProgressBar"
          @click="expandControls"
          @dblclick="playOrPause"
          x-webkit-airplay="allow"
          x5-video-orientation="portrait"
          @ended="onEnded"
          @loadedmetadata="onLoaded"
        ></video>

        <!-- 视频进度条 -->
        <div class="detail-video-progress" v-show="showControls">
          <van-row>
            <van-col span="3" class="detail-video-progress-time">{{
              currentTime
            }}</van-col>
            <van-col span="18">
              <Slider
                v-model="videoProgress"
                @change="onSliderChange($event)"
                @drag-start="onDrag(true)"
                @drag-end="onDrag(false)"
                button-size="10"
                active-color="#fff"
              />
            </van-col>
            <van-col span="3" class="detail-video-progress-time">{{
              duration
            }}</van-col>
          </van-row>
        </div>

        <!-- 暂停/播放按钮 -->
        <div class="icon-play">
          <van-icon
            name="pause-circle-o"
            color="white"
            v-show="iconPauseShow && showControls"
            size="60"
            @click.prevent="pauseVideo"
          />
          <van-icon
            name="play-circle-o"
            color="white"
            v-show="iconPlayShow && showControls"
            size="60"
            @click.prevent="playVideo"
          />
        </div>
      </div>
      <div class="detail-title">
        {{ videoName }}
      </div>
      <div class="detail-more">
        <Tabs
          v-model="activeTab"
          color="#1989fa"
          title-inactive-color="#333333"
          title-active-color="#1989fa"
          :border="true"
        >
          <Tab title="介绍">
            <div class="detail-more-info">
              {{ videoInfo }}
            </div>
          </Tab>
          <Tab title="目录">
            <van-cell
              v-for="item in videoList"
              :key="item.productId"
              class="detail-more-list"
            >
              <div
                :class="{ 'title--active': item.selected }"
                @click="switchVideo(item)"
              >
                <span style="font-weight: bold">{{ item.productNo }}</span
                >&nbsp;
                <span>{{ item.videoName }}</span>
              </div>
            </van-cell>
          </Tab>
        </Tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { Slider, Tab, Tabs } from "vant";
import { getVideoOrder } from "api/onLine";
export default {
  components: { Slider, Tab, Tabs },
  data() {
    return {
      videoOrderId: -1,
      productId: -1,
      videoName: "",
      videoUrl: "",
      videoInfo: "",
      playing: false,
      showControls: true,
      iconPlayShow: true,
      iconPauseShow: false,
      height: null,
      videoProgress: 0,
      currentTime: "00:00",
      duration: "00:00",
      timedEventId: -1,
      activeTab: 1,
      videoList: [],
    };
  },
  created() {
    var videoOrderId = this.$route.query.videoOrderId;
    if (videoOrderId == undefined) {
      this.videoOrderId = -1;
    } else {
      this.videoOrderId = videoOrderId;
    }
    var productId = this.$route.query.productId;
    if (productId == undefined) {
      this.productId = -1;
    } else {
      this.productId = productId;
    }
    this.loadVideo();
  },
  mounted() {
    // 计算视频组件高度
    if (window.innerHeight) {
      this.height = window.innerHeight - 46;
    }
  },
  methods: {
    // 返回订单列表
    onClickLeft() {
      this.$push({
        path: "/orders?type=-1",
      });
    },
    // 加载视频信息
    loadVideo() {
      getVideoOrder(this.videoOrderId, this.productId).then((res) => {
        if (res.status == 200 && res.data) {
          this.videoName = res.data.videoName;
          this.videoUrl = `http://${res.data.videoUrl}`;
          this.videoCover = res.data.videoCover;
          if (!res.data.videoInfo || res.data.videoInfo === "") {
            this.videoInfo = "该视频暂无介绍";
          } else {
            this.videoInfo = res.data.videoInfo;
          }
          this.videoList = res.data.videoList;
        } else {
          this.$error("获取视频失败，请稍后重试");
        }
      });
    },
    // 显示/隐藏视频控制组件
    expandControls() {
      this.showControls = !this.showControls;
      if (this.showControls && this.playing) {
        this.timedEventId = this.hideControls();
      } else {
        this.clearHideEvent();
      }
    },
    // 一段时间无操作后隐藏视频控制组件
    hideControls() {
      return setTimeout(() => {
        if (this.timedEventId != -1) {
          this.showControls = false;
          this.timedEventId = -1;
        }
      }, 3000);
    },
    // 清除隐藏控件延时任务
    clearHideEvent() {
      if (this.timedEventId != -1) {
        clearTimeout(this.timedEventId);
        this.timedEventId = -1;
      }
    },
    // 播放视频
    playVideo() {
      const videoEl = this.$el.querySelector("video");
      videoEl.play();
      this.playing = true;
      this.iconPlayShow = false;
      this.iconPauseShow = true;
      this.timedEventId = this.hideControls();
    },
    // 暂停视频
    pauseVideo() {
      this.clearHideEvent();
      const videoEl = this.$el.querySelector("video");
      videoEl.pause();
      this.playing = false;
      this.iconPlayShow = true;
      this.iconPauseShow = false;
    },
    // 暂停/播放视频
    playOrPause() {
      if (this.playing) {
        this.pauseVideo();
      } else {
        this.playVideo();
      }
    },
    // 视频播放完毕
    onEnded() {
      this.clearHideEvent();
      this.videoProgress = 100;
      this.currentTime = this.duration;
      this.playing = false;
      this.showControls = true;
      this.iconPauseShow = false;
      this.iconPlayShow = true;
    },
    // 视频加载完毕
    onLoaded() {
      const videoEl = this.$el.querySelector("video");
      this.duration = this.timeFormatter(videoEl.duration);
    },
    // 改变进度条进度
    onSliderChange(e) {
      this.clearHideEvent();
      const videoEl = this.$el.querySelector("video");
      videoEl.currentTime = (e / 100) * videoEl.duration;
      if (this.playing) {
        this.timedEventId = this.hideControls();
      }
    },
    // 进度条拖拽事件，拖拽时暂停视频播放
    onDrag(drag) {
      this.clearHideEvent();
      if (this.playing) {
        const videoEl = this.$el.querySelector("video");
        if (drag) {
          videoEl.pause();
        } else {
          videoEl.play();
          this.timedEventId = this.hideControls();
        }
      }
    },
    // 根据当前视频时间更新进度条
    updateProgressBar() {
      const videoEl = this.$el.querySelector("video");
      this.videoProgress = (videoEl.currentTime / videoEl.duration) * 100;
      this.currentTime = this.timeFormatter(videoEl.currentTime);
      this.lastTime = videoEl.currentTime;
    },
    // 时间格式化  秒-->MM:SS
    timeFormatter(time) {
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;
      return (
        minutes.toFixed(0).padStart(2, "0") +
        ":" +
        seconds.toFixed(0).padStart(2, "0")
      );
    },
    // 切换视频
    switchVideo(item) {
      this.videoList.forEach((data) => {
        data.selected = false;
        if (data.productId == item.productId) {
          data.selected = true;
        }
      });
      this.videoName = item.videoName;
      this.videoUrl = `http://${item.videoUrl}`;
      this.videoCover = item.videoCover;
      if (!item.videoInfo || item.videoInfo === "") {
        this.videoInfo = "该视频暂无介绍";
      } else {
        this.videoInfo = item.videoInfo;
      }
      this.playing = false;
      this.showControls = true;
      this.iconPlayShow = true;
      this.iconPauseShow = false;
      this.videoProgress = 0;
      this.currentTime = "00:00";
      this.duration = "00:00";
      const videoEl = this.$el.querySelector("video");
      videoEl.load();
    },
  },
};
</script>

<style scoped lang="less">
.watch-content {
  width: 100%;
  height: 100%;
  background: #f2f3f5;
}
.headerNav {
  height: 46px;
  /deep/.van-nav-bar {
    color: #fff;
    .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title,
    a {
      color: inherit;
      vertical-align: middle;
    }
    .van-nav-bar__title {
      font-size: 18px;
    }
    .van-icon,
    .iconfont {
      font-size: 24px;
      vertical-align: middle;
    }
    .iconjiantou1 {
      font-size: 26px;
    }
  }
  .van-nav-bar::after {
    content: "";
    border: none;
  }
}
.detail-video {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  &-content {
    width: 100%;
    object-fit: contain;
  }
  &-progress {
    position: absolute;
    width: 100%;
    bottom: 3%;
    z-index: 1;
    &-time {
      font-size: 10px;
      text-align: center;
      color: white;
    }
  }
  .icon-play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    opacity: 0.6;
  }
}
.detail-title {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 16px;
  background: white;
  font-size: 18px;
  font-weight: bold;
}
.detail-more {
  margin-top: 12px;
  background: white;
  &-info {
    padding-top: 12px;
    padding-right: 10px;
    padding-bottom: 24px;
    padding-left: 10px;
    text-indent: 2em;
  }
  &-list {
    font-size: 15px;
    padding: 14px 16px;
  }
}
/deep/.van-tab--active {
  font-weight: bold;
}
.title--active {
  color: #1989fa;
}
.van-slider {
  background-color: gray;
  height: 5px;
  margin-top: 3px;
}
</style>
